
import DOMPurify from 'dompurify';

export const sanitizeHTML = (html: string | null | undefined): string => {
	if (!html) {
		return '';
	}
	return DOMPurify.sanitize(html, {
		// Добавляем тег iframe в список разрешённых
		ADD_TAGS: ['iframe'],

		// Разрешаем необходимые атрибуты для iframe
		ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height', 'target', 'rel'],
		// ALLOWED_URI_REGEXP: /^(https?:)?\/\/(www\.)?(youtube\.com|vimeo\.com)\//i, // Разрешаем только YouTube и Vimeo

	}).trim();
};
